/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import useDeviceScreen from 'root/hooks/useDeviceScreen';
import { useAmp } from 'next/amp';

const Loading = ({ mobile, desktop }) => {
  const { isMobile } = useDeviceScreen();
  const isAmp = useAmp();
  const width = (isAmp || isMobile) ? mobile.width : desktop.width;
  const height = (isAmp || isMobile) ? mobile.height : desktop.height;

  return !isMobile ? (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="18" y="14" rx="3" ry="3" width="950" height="30" />
      <rect x="40" y="60" rx="3" ry="3" width="90" height="25" />
      <rect x="140" y="60" rx="3" ry="3" width="90" height="25" />
      <rect x="240" y="60" rx="3" ry="3" width="90" height="25" />
      <rect x="340" y="60" rx="3" ry="3" width="90" height="25" />
      <rect x="440" y="60" rx="3" ry="3" width="90" height="25" />
      <rect x="540" y="60" rx="3" ry="3" width="90" height="25" />
      <rect x="640" y="60" rx="3" ry="3" width="90" height="25" />
      <rect x="740" y="60" rx="3" ry="3" width="90" height="25" />
      <rect x="840" y="60" rx="3" ry="3" width="90" height="25" />
      <rect x="90" y="100" rx="3" ry="3" width="90" height="25" />
      <rect x="190" y="100" rx="3" ry="3" width="90" height="25" />
      <rect x="290" y="100" rx="3" ry="3" width="90" height="25" />
      <rect x="390" y="100" rx="3" ry="3" width="90" height="25" />
      <rect x="490" y="100" rx="3" ry="3" width="90" height="25" />
      <rect x="590" y="100" rx="3" ry="3" width="90" height="25" />
      <rect x="690" y="100" rx="3" ry="3" width="90" height="25" />
      <rect x="790" y="100" rx="3" ry="3" width="90" height="25" />
    </ContentLoader>
  ) : (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="18" y="14" rx="3" ry="3" width="950" height="30" />
      <rect x="40" y="60" rx="3" ry="3" width="90" height="25" />
      <rect x="140" y="60" rx="3" ry="3" width="90" height="25" />
      <rect x="240" y="60" rx="3" ry="3" width="90" height="25" />
    </ContentLoader>
  );
};

Loading.propTypes = {
  mobile: PropTypes.object,
  desktop: PropTypes.object,
};

export default Loading;
